//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum AggregationStatType {
  Comments = 'comments',
  EngagementRate = 'engagementrate',
  Followers = 'followers',
  Likes = 'likes',
  Reach = 'reach',
  Impressions = 'impressions',
  Views = 'views',
  StoryCompletionRate = 'completion',
  EngagementRateWithReach = 'engagementratewithreach',
  Repins = 'repins',
}

type PostStatAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.EngagementRate
  | AggregationStatType.EngagementRateWithReach
  | AggregationStatType.Followers
  | AggregationStatType.Impressions
  | AggregationStatType.Likes
  | AggregationStatType.Reach
  | AggregationStatType.Views;
export type PostsStatAggregationArray =
  IAggregationStat<PostStatAggregationType>[];

export type PostStatHistogramAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.EngagementRate
  | AggregationStatType.EngagementRateWithReach
  | AggregationStatType.Followers
  | AggregationStatType.Likes
  | AggregationStatType.Reach;
export type PostsStatHistogramArray =
  IAggregationResultHistogramBucket<PostStatHistogramAggregationType>[];

export interface IAggregationStat<T extends AggregationStatType> {
  name: T;
  value: IAggregationStatValue;
}

interface IAggregationStatValue {
  avg: number;
  max: number;
  min: number;
  sum: number;
}

export interface IAggregationResultHistogramBucket<
  T extends AggregationStatType,
> {
  date: Date;
  count: number;
  stats: IAggregationStat<T>[];
}
